import HorizontalCard from 'components/HorizontalCard';
import MainLayout from 'Layout/MainLayout'
import React, { useContext } from 'react'
import ImRegis from 'assets/images/im-register.jpg';
import MainButton from 'components/MainButton';
import Field from 'components/Field';
import Kabupaten from 'components/Kabupaten';
import Provinsi from 'components/Provinsi';
import Kecamatan from 'components/Kecamatan';
import { toast } from "react-toastify";
import Desa from 'components/Desa';
import { userContext } from 'Context/userContext';
import { useState } from 'react';
import { registerDesa } from 'services/apiRoutes';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';

export default function Register() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: "",
      email: "",
      wa: "",
      kecamatan: "",
      kabupaten: "",
      provinsi: "",
      kelurahan: "",
      kepaladesa:'',
      alamat:'',
    },
  });


  const navigate = useNavigate()
  const dataContext = useContext(userContext);
  const [loading,setLoading]=useState(false);
  const[nama,setNama]=useState()
  const[email,setEmail]=useState()
  const[telp,setTelp]=useState()
  const [prov,setProv]=useState(11)
  const [kab, setKab] = useState(1101);
  const [kec, setKec] = useState(110101);
  const [kel,setKel]=useState('')
  const [pejabat,setPejabat]=useState()
  const [alamat,setAlamat]=useState()
  const [alasan,setAlasan]=useState();

   const create_date = `${new Date().toLocaleString()}`;


     const onSubmit = async () => {
       const data = {
         nama_pendaftar: nama,
         email,
         telp,
         kode_prov: prov,
         kode_kab: kab,
         kode_kec: kec,
         kode_kel: kel,
         pejabat_desa: pejabat,
         alamat,
         alasan,
         create_date,
       };

       setLoading(true);
       const res = await registerDesa(data);
       if (res.error) {
         setLoading(false);
         toast.error(res.message)
         return res.messages;
       } else {
         setLoading(false);
         toast.success(res.message);
         setTimeout(() => {
           navigate('/success');
         }, 1000);
       }
     };

  return (
    <MainLayout active="register">
      <div className="relative px-5 xl:pt-44 pt-28 kegiatan-wrapper xl:px-99">
        <h1 className="text-2xl font-bold xl:mb-20 mb-14 xl:text-7xl">
          Registrasi Desa
        </h1>
        <div className="space-y-24 wrapperCad">
          <HorizontalCard
            // desc="90% Masyarakat Gampong Geulanggang teungoh adalah Petani"
            title="Daftarkan Desa Anda"
            img={ImRegis}
          />
        </div>
        <form action="" onSubmit={handleSubmit(onSubmit)}>
          <div className="space-y-3 mt-14 searchWrapper mb-14">
            <Field
              name="name"
              label="Nama Pendaftar"
              placeholder="Masukkan nama pendaftar"
              onChange={(e) => setNama(e.target.value)}
              register={register("name", { required: "Nama wajib diisi" })}
              error={errors.name}
            />
            <Field
              name="email"
              label="Email"
              placeholder="Masukkan email"
              // onChange={register("email", {
              //   onChange: (e) => setEmail(e.target.value),
              // })}
              onChange={(e) => setEmail(e.target.value)}
              register={register("email", {
                required: "Email wajib diisi",
                pattern: {
                  value:
                    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                  message: "Email tidak sesuai format",
                },
              })}
              error={errors.email}
            />
            <Field
              name="wa"
              label="Nomor Telepon/Whatsapp"
              placeholder="Masukkan Nomor Telepon/Whatsapp"
              register={register("wa", { required: "No Hp wajib diisi" })}
              onChange={(e) => setTelp(e.target.value)}
              error={errors.wa}
            />
            <div className="grid-cols-2 gap-5 md:grid">
              <Provinsi
                onChange={(e) => {
                  setProv(e.target.value);
                  dataContext?.setProv(e.target.value);
                }}
              />
              <Kabupaten
                onChange={(e) => {
                  setKab(e.target.value);
                  dataContext?.setKab(e.target.value);
                }}
                setValue={dataContext?.kab}
              />
            </div>
            <div className="grid-cols-2 gap-5 md:grid">
              <Kecamatan
                onChange={(e) => {
                  setKec(e.target.value);
                  dataContext?.setKec(e.target.value);
                }}
              />
              <Desa onChange={(e) => setKel(e.target.value)} />
            </div>
            <Field
              name="kepaladesa"
              label="Nama Kepala/Pejabat Desa"
              placeholder="Masukkan Nama Kepala/Pejabat Desa"
              onChange={(e) => setPejabat(e.target.value)}
              register={register("kepaladesa", { required: "Wajib diisi" })}
              error={errors.alamat}
            />
            <Field
              name="alamat"
              label="Alamat Kantor Desa"
              placeholder="Masukkan Alamat Kantor Desa"
              onChange={(e) => setAlamat(e.target.value)}
              register={register("alamat", { required: "Wajib diisi" })}
              error={errors.alamat}
            />
            <div className="mx-2 mt-8 text-sm font-semibold">
              Alasan Ingin Bergabung (Opsional)
            </div>
            <textarea
              placeholder="Alasan Ingin Bergabung (Opsional)"
              onChange={(e) => setAlasan(e.target.value)}
              name="pesan"
              id="message"
              cols="30"
              rows="10"
              className="w-full p-5 mb-12 border rounded-2xl focus:ring-2 focus:ring-primary focus:border-none focus:outline-none"
            />
          </div>
          <div className="mb-64 sendWrapper">
            <MainButton
              type="submit"
              label="Daftar"
              loading={loading}
              onSubmit={handleSubmit(onSubmit)}
              onClick={handleSubmit(onSubmit)}
            />
          </div>
        </form>
      </div>
    </MainLayout>
  );
}
